import { render, staticRenderFns } from "./iGallery.vue?vue&type=template&id=3200f5ac&scoped=true&"
import script from "./iGallery.vue?vue&type=script&lang=js&"
export * from "./iGallery.vue?vue&type=script&lang=js&"
import style0 from "./iGallery.vue?vue&type=style&index=0&id=3200f5ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3200f5ac",
  null
  
)

export default component.exports